import React from "react";
import ReactDOM from "react-dom/client";
import "./style.css";
import App from "./App.tsx";

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
